import FileSize from "../../../../components/commonComponent/FileSize";
import {
  CardWrapper,
  Portrait,
  InfoCard,
  Name,
  Designation,
} from "./Leadership.styles";

import divider from "../../../../assets/pages/landing/leaders/divider.svg";

const LeaderCard = ({ image, name, designation, profilePdf }) => {
  return (
    <CardWrapper>
      {profilePdf ? (
        <a
          href={profilePdf}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`View ${name}'s profile (PDF, opens in a new tab)`}
          className="max-w-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <Portrait src={image} alt={name} />
          <FileSize href={profilePdf} />
        </a>
      ) : (
        <Portrait src={image} alt={name} />
      )}

      <InfoCard>
        <Name>{name}</Name>
        <img className="w-full" src={divider} alt="" />
        <Designation>{designation}</Designation>


      </InfoCard>
    </CardWrapper>
  );
};

export default LeaderCard;
